import request from '@/utils/request'

const searchGlobal = (data) => {
  return request({
    path: `/global-search?query=${data}&sources[]=merchant_orders`,
    method: 'GET',
  })
}

export { searchGlobal }
